import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  const phoneNumber = "+919404515431";
  const message = "Hi, I would like to know more about your RERA services.";
  const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float bg-[#25D366] w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-button"
    >
      <MessageCircle size={28} className="text-white" />
    </a>
  );
};

export default WhatsAppButton;